import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import ModuleHeader from './PageHeader'
import ModuleContent from './PageContent'
import styles from '../styles'

const Module = ({
  classes,
  module,
  sectionIndex,
  moduleIndex,
  expandedModules,
  moduleTitleRefs,
  goalRefs,
  popupStates,
  anchorElements,
  fieldSuggestions,
  popupLoadingStates,
  onModuleTitleChange,
  onPageTitleSuggestions,
  pageTitleSuggestions,
  onToggleModule,
  onAddGoal,
  onRemoveGoal,
  onGoalChange,
  onGoalFocus,
  onRegenerateSuggestions,
  onPopupClose,
  onSuggestionClick,
  onAddPage,
  onDeletePage,
  getFileInfo,
  onGoalKeyDown,
  documentFollowing,
  setDocumentFollowing,
}) => {
  return (
    <Draggable
      key={`module-${sectionIndex}-${moduleIndex}`}
      draggableId={`module-${sectionIndex}-${moduleIndex}`}
      index={moduleIndex}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={classes.pageContainer}
        >
          <ModuleHeader
            classes={classes}
            module={module}
            sectionIndex={sectionIndex}
            moduleIndex={moduleIndex}
            moduleTitleRefs={moduleTitleRefs}
            expandedModules={expandedModules}
            onModuleTitleChange={onModuleTitleChange}
            onPageTitleSuggestions={onPageTitleSuggestions}
            pageTitleSuggestions={pageTitleSuggestions}
            onToggleModule={onToggleModule}
            dragHandleProps={provided.dragHandleProps}
            onDeletePage={onDeletePage}
            documentFollowing={documentFollowing}
            setDocumentFollowing={setDocumentFollowing}
          />

          <ModuleContent
            classes={classes}
            module={module}
            sectionIndex={sectionIndex}
            moduleIndex={moduleIndex}
            expandedModules={expandedModules}
            goalRefs={goalRefs}
            popupStates={popupStates}
            anchorElements={anchorElements}
            fieldSuggestions={fieldSuggestions}
            popupLoadingStates={popupLoadingStates}
            onAddGoal={onAddGoal}
            onRemoveGoal={onRemoveGoal}
            onGoalChange={onGoalChange}
            onGoalFocus={onGoalFocus}
            onRegenerateSuggestions={onRegenerateSuggestions}
            onPopupClose={onPopupClose}
            onSuggestionClick={onSuggestionClick}
            onAddPage={onAddPage}
            getFileInfo={getFileInfo}
            onGoalKeyDown={onGoalKeyDown}
            documentFollowing={documentFollowing}
            setDocumentFollowing={setDocumentFollowing}
          />
        </div>
      )}
    </Draggable>
  )
}

export default withStyles(styles)(Module)
